<script setup lang="ts">
import Menu from "~/layouts/-components/Menu.vue";
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();

const navigation = ref([
  { to: "/bli-kund", text: "Bli kund" },
  { to: "/elavtal", text: "Elavtal" },
  { to: "/foretag-brf", text: "Företag/BRF  " },
  { to: "/salj-din-el", text: "Sälj din el" },
  { to: "/kundservice", text: "Kundservice" },
  { to: "/nyheter", text: "Nyheter" },
  { to: "/om-oss", text: "Om oss" },
]);

const isActive = (path:string) => {
  return route.path === path;
}
</script>

<template>
  <div class="header sticky z-40 top-0 bg-theme pb-12 pt-30 max-lg:hidden text-gray-light" ref="target" style="box-shadow: 0 2px 8px #000">
    <div class="flex justify-between container items-center">
      <div class="header__logo w-[150px] relative top-[-10px] transform -translate-y-[6px]">
        <nuxt-link to="/">
          <svgo-logo class="block" />
        </nuxt-link>
      </div>

      <div v-for="(nav, i) in navigation" :key="i">
        <nuxt-link
          class="text-18 hover:text-cyan max-lg:hidden"
          :to="nav.to"
          :key="i"
          :class="{ 'text-cyan font-semibold text-20': isActive(nav.to)}"
        >
          {{ nav.text }}
        </nuxt-link>
      </div>
    </div>
  </div>
  <Menu class="lg:hidden" />
</template>

<style scoped lang="scss">
.header a {
  transition: all 0.5s ease;
}

.is-sticky {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding-bottom: 10px;
}
</style>
